import {
    type FC
} from "react";
import {
    Animated,
    View
} from "react-native";
import type IStepperConnectorProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useAnimatedState
} from "../../../../helpers/motion";
import {
    usePointerType
} from "../../../../helpers/pointer";
import type {
    StepperItemPartContentProps
} from "../../type";
import {
    withStepperItemContext
} from "../../context";
import {
    getStepperMeasures
} from "../../stylesheet";

const StepperConnectorContent: FC<StepperItemPartContentProps<IStepperConnectorProps>> = ({
    customTheme: customThemeProp,
    isDone: isDoneProp,
    context,
    style,
    item,
    ...props
}) => {
    const customTheme = customThemeProp ?? context.customTheme;

    const {
        controlPaddings,
        controlHeights,
        shapeConfigs,
        touchTargets,
        typography,
        iconSizes,
        radiuses,
        borders,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const pointerType = usePointerType();

    const isDone = isDoneProp ?? item.isDone;

    const isSkipped = item.status === "skipped";

    const progress = useAnimatedState({
        isNativeDriverEnabled: false,
        intent: "valueChange",
        value: isDone ? 1 : 0,
        customTheme
    });

    const measures = getStepperMeasures({
        orientation: context.orientation,
        isInSheet: context.isInSheet,
        size: context.size,
        controlPaddings,
        controlHeights,
        shapeConfigs,
        touchTargets,
        pointerType,
        typography,
        iconSizes,
        borders,
        spaces
    });

    const {
        container: containerDynamicStyle,
        fill: fillDynamicStyle
    } = useStyles({
        isSkipped,
        measures,
        radiuses,
        colors,
        spaces
    });

    return <View
        {...props}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
        aria-hidden={true}
    >
        {
            isSkipped ?
                null
            :
                <Animated.View
                    style={[
                        stylesheet.fill,
                        fillDynamicStyle,
                        {
                            width: progress.interpolate({
                                outputRange: [
                                    "0%",
                                    "100%"
                                ],
                                inputRange: [
                                    0,
                                    1
                                ]
                            })
                        }
                    ]}
                />
        }
    </View>;
};
export default withStepperItemContext("Connector", StepperConnectorContent);
